import FormattedMessage from 'I18n/components/FormattedMessage';
import { HR } from 'foundations-components/transitional/components/HR';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error untyped dep
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { HelpLink } from 'foundations-components/transitional/components/HelpLink';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Urls } from 'ExportDialog/Constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function createValueExtractor(onChangeCallback) {
  return event => {
    onChangeCallback(event.target.value);
  };
}
const stateToLang = {
  VALID: null,
  INVALID: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "exportDialog.emailErrors.invalidEmail"
  })
};
const isSend = preference => {
  return preference === 'SEND';
};
const isEmailNotValid = validationState => {
  return validationState !== 'VALID';
};
const getNotificationText = (email, notification, value) => {
  if (email && notification) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "exportDialog.preference.exportToBothText_jsx",
      options: {
        url: Urls.notificationCenterUrl,
        value,
        auditUrl: Urls.exportAuditUrl
      },
      elements: {
        Link
      }
    });
  } else if (email) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "exportDialog.preference.exportToEmailText_jsx",
      options: {
        value,
        auditUrl: Urls.exportAuditUrl
      },
      elements: {
        Link
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "exportDialog.preference.exportToNotificationCenterText_jsx",
      options: {
        url: Urls.notificationCenterUrl,
        auditUrl: Urls.exportAuditUrl
      },
      elements: {
        Link
      }
    });
  }
};
const getEmailInputField = (validationState, value, onChange) => {
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "exportDialog.fields.emailAddressLabel"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "exportDialog.fields.emailAddressLabelDescription"
    }),
    error: validationState !== 'VALID',
    validationMessage: stateToLang[validationState],
    children: /*#__PURE__*/_jsx(TextInput, {
      defaultValue: value,
      onBlur: createValueExtractor(onChange)
    })
  });
};
const getNotificationHelpText = (preferences, value) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "small",
    use: "help",
    children: getNotificationText(isSend(preferences.EMAIL), isSend(preferences.NOTIFICATION_SIDEBAR), value)
  });
};
const LinkWrapper = props => {
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    children: /*#__PURE__*/_jsx(KnowledgeBaseButton, Object.assign({}, props))
  });
};
const EmailFieldAndNotificationHelpText = ({
  onChange,
  validationState,
  value,
  preferences
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      justifyContent: "space-between",
      flexDirection: "row",
      paddingBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h6",
          paddingBlockStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "exportDialog.preference.sendTo"
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          children: /*#__PURE__*/_jsx(HelpLink, {
            defaultOpen: false,
            showCloseButton: true,
            content: {
              body: /*#__PURE__*/_jsx(View, {
                paddingBlock: "300",
                children: /*#__PURE__*/_jsx(Text, {
                  as: "small",
                  use: "help",
                  textAlign: "center",
                  children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                    message: "exportDialog.preference.allowlistHelpText_jsx",
                    options: {
                      allowlistUrl: {
                        url: Urls.allowlistUrl
                      },
                      notificationUrl: {
                        url: Urls.notificationUrl
                      }
                    },
                    elements: {
                      KBLink: LinkWrapper
                    }
                  })
                })
              })
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "exportDialog.preference.notGettingEmail"
            })
          })
        })
      })]
    }), isEmailNotValid(validationState) ? getEmailInputField(validationState, value, onChange) : getNotificationHelpText(preferences, value), /*#__PURE__*/_jsx(HR, {})]
  });
};
export default EmailFieldAndNotificationHelpText;